/** Roman numeral months I–XII = January–December (Strapi `roman_quarter`). */
export const ROMAN_MONTHS = [
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
  'XI',
  'XII',
] as const;

export type RomanMonth = (typeof ROMAN_MONTHS)[number];

const ID_MONTH = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
] as const;

export function romanMonthMenuItems(): { value: RomanMonth; label: string }[] {
  return ROMAN_MONTHS.map((r, i) => ({
    value: r,
    label: `${r} — ${ID_MONTH[i]}`,
  }));
}

/** Roman month for the given calendar date (LOCAL month index 0–11). */
export function defaultRomanMonthForDate(d = new Date()): RomanMonth {
  return ROMAN_MONTHS[d.getMonth()];
}
